const ChevronUpIcon = (props: any) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={20}
    height={20}
    fill="none"
    {...props}
  >
    <path
      fill="currentColor"
      d="M10 9.125l3.938 3.938L15 12l-5-5-5 5 1.063 1.063L10 9.124Z"
    />
  </svg>
);

export default ChevronUpIcon;
